<template lang="pug">
  //- 选择就诊人弹框组件
  cPicker(
    :show='show'
    :slots="slots"
    valueKey='patient_name'
    @change="change"
    @confirmClick='confirmClick'
    extraText='添加就诊人'
    @extraClick='addPatient'
  )
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  props: ['hosId', 'show', 'withoutJump', 'patId', 'hospital_area_id'],
  data() {
    return {
      card: '',
      patient: {}
    }
  },
  async created() {
    // 获取医院详情，如果请求的内容与存储内容相同则不请求
    // if (this.hosId !== this.hosDetail.hos_id && this.hosId) {
    if (this.hosId) {
      await this.loadDetail({
        type: 'registration_hospital_detail_new',
        module: 'registration',
        hospital_area_id: this.hospital_area_id,
        hos_id: this.hosId,
        page: 1
      })
    }
    // }
    // 请求所有就诊人，如果已存在就不需要请求
    // 如果传入hosId为0则请求所有的就诊人
    if (this.patList && this.patList.length <= 0) {
      await this.loadList({
        type: 'ucenter_patient_list_new',
        module: 'ucenter',
        userId: this.$user_id,
        page: 1
      }).then((data) => {
        if (data.length === 0) {
          this.$toast('未查询到符合条件的就诊人，请先添加就诊人')
          this.$router.push('/ucenter_add_patient_new?action=payment')
        }
      })
    }
  },
  computed: {
    ...mapState({
      patList: (state) => state.ucenter.ucenter_patient_list_new,
      hosDetail: (state) => state.registration.registration_hospital_detail_new,
      slots: (state) => state.registration.registration_select_patients
    })
  },
  watch: {
    patList() {
      this.filterPatients()
    },
    hosDetail() {
      this.filterPatients()
    }
  },
  methods: {
    ...mapActions(['loadDetail', 'loadList']),
    ...mapMutations(['setData']),
    confirmClick() {
      this.$emit('confirmClick')
    },
    change(picker, values) {
      this.patient = values[0]
      this.setCard()
    },
    addPatient() {
      this.$router.push('/ucenter_add_patient_new?action=payment')
    },
    // 设置就诊卡
    setCard() {
      if (this.patient && this.patient.id) {
        if (this.patId) {
          this.patient = this.patList.filter((item) => {
            return item.id === Number(this.patId)
          })[0]
        }
        if (this.patient.card_list.length <= 0) {
          this.card = ''
        } else {
          let cards = this.patient.card_list.filter((item) => {
            return item.hospital_area_id == this.hospital_area_id || item.hospital_code == this.hosId
          })
          this.card =
            cards.length > 0
              ? (() => {
                  return cards[0].jz_card
                })()
              : ''
        }
        this.name = this.patient.patient_name
        this.$emit('change', this.name, this.card, this.patient)
      }
    },
    // 过滤就诊人
    filterPatients() {
      let patiends = this.patList

      // 设置就诊人列表
      this.setData({
        module: 'ucenter',
        dataType: 'ucenter_equal_patients',
        data: patiends
      })
      // 设置可选择的就诊人列表
      this.setData({
        module: 'registration',
        dataType: 'registration_select_patients',
        data: [
          {
            values: patiends
          }
        ]
      })
      // 设置初始就诊人
      this.patient = patiends.length > 0 ? patiends[0] : ''
      this.name = this.patient.patient_name
      if (this.patient.card_list && this.patient.card_list.length > 0) {
        this.setCard()
      }
    }
  }
}
</script>

<style lang="less" scoped></style>
